import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 支持的语言列表
const supportedLangsList = ['en', 'kr', 'de', 'sa', 'jp', 'th']
const defaultLang = 'en'

// 基础路由配置（不包含语言前缀）
const baseRoutes = [
  {
    path: '',
    name: 'index',
    component: () => import('@/pages/index/index.vue'),
    meta: { keepAlive: true },
  },
  {
    path: 'ranking',
    name: 'ranking',
    component: () => import('@/pages/ranking/index.vue')
  },
  {
    path: 'search',
    name: 'search',
    component: () => import('@/pages/search/index.vue')
  },
  {
    path: 'bookDetail',
    name: 'detail',
    component: () => import('@/pages/bookdetail/index.vue')
  },
  {
    path: 'about',
    name: 'about',
    component: () => import('@/pages/about/index.vue')
  },
  {
    path: 'vip',
    name: 'vip',
    component: () => import('@/pages/vip/index.vue')
  },
  {
    path: 'privacy',
    name: 'privacy',
    component: () => import('@/pages/privacy/index.vue')
  },
  {
    path: 'service',
    name: 'service',
    component: () => import('@/pages/service/index.vue')
  },
  {
    path: 'reader',
    name: 'reader',
    component: () => import('@/pages/bookReader/index.vue')
  },
  {
    path: 'agreement',
    name: 'agreement',
    component: () => import('@/pages/agreement/index.vue')
  },
]

// 构建所有路由
const allRoutes = []

// 为每种语言创建路由
supportedLangsList.forEach(lang => {
  const isDefaultLang = lang === defaultLang
  const pathPrefix = isDefaultLang ? '/' : `/${lang}`
  
  allRoutes.push({
    path: pathPrefix,
    component: () => import(/* webpackChunkName: "home" */ '@/components/layout/index.vue'), // 关键：父路由必须有组件
    meta: { lang },
    children: baseRoutes.map(route => ({
      ...route,
      name: isDefaultLang ? route.name : `${route.name}_${lang}`,
      meta: {
        ...route.meta,
        lang
      }
    }))
  })
})

// 添加重定向规则
allRoutes.push(
  // 将 /en 重定向到 /
  {
    path: '/en',
    redirect: '/'
  },
  // 将 /en/* 重定向到 /*
  {
    path: '/en/:path(.*)',
    redirect: to => `/${to.params.path}`
  },
)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: allRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})


router.onError((error) => {
  console.error('路由错误:', error)
})

export default router